export const BRAND = {
  APP_NAME: "Configurador Paquete Full Equipado",
  EVENT: "Argentina Mining Norte 2026",
  LOGO_AM: "https://customer-assets.emergentagent.com/job_configurador-mining/artifacts/pcld9e7i_logo%20am%20norte%20oscuro.png",
  LOGO_SO: "https://customer-assets.emergentagent.com/job_configurador-mining/artifacts/m4vl4kj7_Servicios_Oficiales_Logo-removebg-preview.png",
  STAND_PHOTO: "https://customer-assets.emergentagent.com/job_configurador-mining/artifacts/4l7ndbcm_Stand%20-%20Pymes4.png",
  STAND_PHOTO_ALT: "https://customer-assets.emergentagent.com/job_configurador-mining/artifacts/5dyb4j5t_con%20gente.png",
  REF_STAND_3P: "https://customer-assets-7cd3h4nn.emergentagent.net/job_configurador-mining/artifacts/f0mqgpen_Graficas%20-%20stand%203%20paredes.png",
  REF_STAND_2P: "https://customer-assets-7cd3h4nn.emergentagent.net/job_configurador-mining/artifacts/y1irv2wx_Graficas%20-%20stand%202%20paredes.png",
};

export const LED_COLORS = [
  { id: "Blanco cálido", hex: "#FFE4B5" },
  { id: "Blanco frío", hex: "#F0F8FF" },
  { id: "Azul", hex: "#2563EB" },
  { id: "Rojo", hex: "#DC2626" },
  { id: "Verde", hex: "#16A34A" },
  { id: "Amarillo", hex: "#FACC15" },
];

export const CARPET_COLORS = [
  { id: "Rojo", hex: "#B91C1C" },
  { id: "Negro", hex: "#0A0A0A" },
  { id: "Gris", hex: "#52525B" },
  { id: "Azul", hex: "#1E3A8A" },
  { id: "Verde", hex: "#166534" },
];

export const STATUS_LABEL = {
  codigo_emitido: "Sin completar",
  en_carga: "Sin completar",
  enviado_para_revisar: "ENVIADO PARA REVISAR",
  pendiente_confirmacion_cliente: "PENDIENTE DE CONFIRMACIÓN",
  aprobado: "APROBADO",
  rechazado: "RECHAZADO",
};

export const ORDER_STATUSES = ["enviado_para_revisar", "pendiente_confirmacion_cliente", "aprobado", "rechazado"];

export const FACTURACION_LABEL = {
  falta_facturar: "FALTA FACTURAR",
  factura_enviada: "FACTURA ENVIADA",
  pagado: "PAGADO",
};

export const FACTURACION_STATUSES = ["falta_facturar", "factura_enviada", "pagado"];

export const isActiveStand = (status) => ORDER_STATUSES.includes(status);

export const TIPO_UBICACION_LABEL = {
  esquina_2p: "Esquina / 2 paredes",
  vecino_3p: "Entre vecinos / 3 paredes",
  peninsula_1p: "Península / 1 pared",
  isla_0p: "Isla / sin paredes",
  sin_definir: "A definir",
  especial: "Especial · requiere validación admin",
};

export const WIZARD_STEPS = [
  { id: 1, key: "bienvenida", label: "Acceso y bienvenida" },
  { id: 2, key: "datos", label: "Datos y facturación" },
  { id: 3, key: "diseno", label: "Logo y diseño" },
  { id: 4, key: "terminaciones", label: "Terminaciones y TV" },
  { id: 5, key: "upgrades", label: "Upgrades" },
  { id: 6, key: "pedido", label: "Pedido final" },
];

// Prestaciones base según flyer
export const PRESTACIONES_BASE = [
  "Stand personalizable",
  "Gráfica completa en paredes",
  "TV LED 42\" (sujeta a disponibilidad)",
  "Alfombra color a elección",
  "Neón LED / tira LED inferior",
  "Iluminación general",
  "Mesa alta",
  "2 sillas altas",
  "Logo en corpóreo",
];

// TV LED extra (pedido especial, se suma a la TV incluida)
export const TV_EXTRA_OPTIONS = [
  { size: "43\"", price: 200 },
  { size: "50\"", price: 230 },
  { size: "55\"", price: 270 },
  { size: "60\"", price: 400 },
  { size: "65\"", price: 480 },
  { size: "75\"", price: 560 },
];
